module.exports = __webpack_public_path__ + "img/icon_contact.0d24a683.svg";